import _ from 'lodash';
import Rollbar from 'rollbar';

const ERRORSTOSKIP = [
  '__gCrWeb',
  '__reactInternalInstance',
  'Minified React error #136',
  'ResizeObserver',
  'getHostNode',
];

const checkIgnore = (isUncaught, args, payload) => {
  try {
    if (_.get(payload, 'body.trace.exception.description') === 'Script error.') {
      return true;
    }
    if (_.has(payload, 'body.trace.exception.message')) {
      return _.some(
        ERRORSTOSKIP,
        error => payload.body.trace.exception.message.indexOf(error) > -1,
      );
    }
    return false;
  } catch (err) {
    return false;
  }
};

const rollbar = new Rollbar({
  accessToken: process.env.ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  hostWhiteList: [
    'breezeway.io',
    'brzway.com',
    'webpack'
  ],
  payload: {
    environment: process.env.CONFIG_NAME,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.GIT_REVISION,
        package_version: process.env.PACKAGE_VERSION,
        // Optionally have Rollbar guess which frames the error was thrown from
        // when the browser does not provide line and column numbers.
        guess_uncaught_frames: true,
      },
    },
  },
  checkIgnore,
});

export default rollbar;
